import React from 'react'
import { get } from 'lodash'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import Avatar from '@material-ui/core/Avatar'
import CardMedia from '@material-ui/core/CardMedia'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import useIconAccessor from 'components/lesson-type-category/icons'
import { useStyles } from './styles'
import { defineMinimumPricePerLesson } from 'utils/defineMinimumPricePerLesson'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import Chip from '@material-ui/core/Chip'
import clsx from 'clsx'
import pluralize from 'lib/pluralize'

export default ({ lessonInfo, lessonCreditBalanceQuantity }) => {
  const [isLessonPacksEnabled] = useFeatureFlags([flags.FLAG_FEAT_LESSON_PACKS])
  const {
    id,
    title,
    durationInMinutes,
    priceInCents,
    locations,
    category = 'OTHER',
    lessonPacks = [],
  } = lessonInfo

  const classes = useStyles()
  const accessor = useIconAccessor()

  const lessonPacksPrice = defineMinimumPricePerLesson(lessonPacks)

  return (
    <>
      <Card key={id} className={classes.root} variant="outlined">
        <Grid container style={{ padding: '16px', alignItems: 'center' }}>
          <Box display="flex" alignItems="center">
            <CardMedia style={{ marginRight: '16px' }}>
              <Avatar className={classes.iconStyled}>
                {accessor[category].icon}
              </Avatar>
            </CardMedia>

            <Typography
              variant="h6"
              className={`${classes.cardHeading} ${classes.captionText}`}
            >
              {title}
            </Typography>
          </Box>
          <Grid
            item
            xs={12}
            className={classes.leftSide}
            style={{ marginTop: '16px' }}
          >
            <div className={classes.cardContent}>
              {priceInCents !== null && !lessonPacksPrice ? (
                <CardActions disableSpacing className={classes.actionBar}>
                  <Typography variant="caption" className={classes.captionText}>
                    ${(priceInCents / 100).toFixed(2)} per lesson / student
                  </Typography>
                </CardActions>
              ) : null}
              {lessonPacksPrice &&
              isLessonPacksEnabled &&
              !lessonCreditBalanceQuantity ? (
                <Box display="flex" alignItems="center">
                  <CardActions disableSpacing className={classes.actionBar}>
                    <Typography
                      variant="caption"
                      className={classes.captionText}
                    >
                      From ${(lessonPacksPrice / 100).toFixed()} / lesson
                    </Typography>
                  </CardActions>
                </Box>
              ) : null}
              {lessonCreditBalanceQuantity ? (
                <Box my={1}>
                  <Chip
                    className={clsx(classes.chip, classes.chipSuccess)}
                    label="Purchased"
                  />
                  <Chip
                    className={clsx(classes.chip, classes.chipInfo)}
                    label={`${lessonCreditBalanceQuantity} ${pluralize(
                      lessonCreditBalanceQuantity,
                      'lesson',
                    )} left`}
                  />
                </Box>
              ) : null}
              <Typography variant="caption" className={classes.captionText}>
                {get(locations, '0.name')}
              </Typography>
            </div>
            <Typography variant="caption" className={classes.captionText}>
              {durationInMinutes} minutes
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </>
  )
}
